import { useEffect, useState } from "react";
import { collection, onSnapshot } from "firebase/firestore";
import { db } from "../../firebase/firebase";
import { useAuth } from "../../context/AuthContext";
import "./ActivityLog.css";

function ActivityLog() {
  const { user } = useAuth();
  const [logs, setLogs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!user) {
      return undefined;
    }

    const unsubscribe = onSnapshot(
      collection(db, "auditLogs"),
      (snapshot) => {
        const records = snapshot.docs
          .map((log) => ({ id: log.id, ...log.data() }))
          .sort((first, second) => {
            const firstTime = first.timestamp?.toMillis?.() || 0;
            const secondTime = second.timestamp?.toMillis?.() || 0;
            return secondTime - firstTime;
          });
        setLogs(records);
        setIsLoading(false);
      },
      () => {
        setError("Activity history could not be loaded.");
        setIsLoading(false);
      }
    );

    return unsubscribe;
  }, [user]);

  return (
    <main className="activity-page">
      <header className="activity-header">
        <span>ACCOUNTABILITY</span>
        <h1>Activity Log</h1>
        <p>See who changed what and when across the AAR workspace.</p>
      </header>

      <section className="activity-panel">
        {isLoading && <p className="activity-state">Loading activity...</p>}
        {error && <p className="activity-error" role="alert">{error}</p>}
        {!isLoading && !error && logs.length === 0 && (
          <p className="activity-state">No activity has been recorded yet.</p>
        )}
        {!isLoading && !error && logs.length > 0 && (
          <div className="activity-table-wrapper">
            <table className="activity-table">
              <thead>
                <tr>
                  <th>USER</th>
                  <th>ACTION</th>
                  <th>RECORD</th>
                  <th>TIME</th>
                </tr>
              </thead>
              <tbody>
                {logs.map((log) => (
                  <tr key={log.id}>
                    <td>
                      <strong>{log.userName}</strong>
                      <small>{log.userEmail}</small>
                    </td>
                    <td><span className="activity-action">{log.action}</span></td>
                    <td>{log.entityTitle || log.entityId}</td>
                    <td>
                      {log.timestamp?.toDate
                        ? log.timestamp.toDate().toLocaleString()
                        : "Pending timestamp"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </section>
    </main>
  );
}

export default ActivityLog;
